import { catchError, concatMap, exhaustMap, filter, map, switchMap } from 'rxjs/operators'
import { isActionOf } from 'typesafe-actions'
import { concat, from, of } from 'rxjs'
import { toast } from 'react-toastify'
import {
  confirmReceivedAmountRequest,
  confirmReceivedAmountSuccess,
  confirmReceivedAmountFailure,
  createSettlementRequest,
  createSettlementSuccess,
  createSettlementFailure,
  getBalancesRequest,
  getHistoryRequest,
} from '../actions'
import { RootEpic } from '../types'

export const confirmReceivedAmountEpic: RootEpic = (action$, state$, { confirmReceivedAmount }) => {
  return action$.pipe(
    filter(isActionOf([confirmReceivedAmountRequest])),
    exhaustMap(({ payload }) =>
      from(
        confirmReceivedAmount({
          token: state$.value.app.authToken as string,
          ...payload,
        }),
      ).pipe(
        map((response) => {
          if (response?.data?.verified) {
            toast.success('Received amount confirmed successfully.')
          } else {
            toast.error('Failed to confirm received amount.')
          }

          return confirmReceivedAmountSuccess(response?.data)
        }),
        catchError((message) => {
          toast.error('Error confirm received amount.')
          return of(confirmReceivedAmountFailure(message))
        }),
      ),
    ),
  )
}

export const requestSettlementEpic: RootEpic = (action$, state$, { requestSettlement, appContext }) => {
  return action$.pipe(
    filter(isActionOf([createSettlementRequest])),
    switchMap(({ payload }) =>
      from(
        requestSettlement({
          ...payload,
          token: state$.value.app.authToken as string,
        }),
      ).pipe(
        concatMap((response) => {
          const actions = []
          if (response.success) {
            appContext().setIsRefreshTransactionsInStore(true)
            toast.success(response.message)
            actions.push(of(getBalancesRequest({ token: state$.value.app.authToken as string })))
            actions.push(of(getHistoryRequest({ page: 1, limit: 10 })))
          }
          actions.push(of(createSettlementSuccess(response)))
          return concat(...actions)
        }),
        catchError((error) => {
          const message = error.response?.data?.data?.message || error?.message || 'Failed to create settlement.'
          toast.error(message)
          return of(createSettlementFailure(message))
        }),
      ),
    ),
  )
}

export default [confirmReceivedAmountEpic, requestSettlementEpic]
